import React from "react";
import { shape, string } from "prop-types";
import { NavLink } from "react-router";
import { Breadcrumbs, Typography } from "@mui/material";
import { breadcrumbStyles } from "shared/theme/styles";
import { tabConfig } from "../config";
import googleAnalytics from "shared/analytics";

const AppBreadcrumbs = ({ location, activeTabKey }) => {
  const trackClick = (whereTo) => {
    googleAnalytics.trackBreadcrumbClick({
      whereTo,
      currentPage: location.pathname,
    });
  };
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator="/"
      sx={{
        ...breadcrumbStyles.root,
        "& .MuiBreadcrumbs-separator": breadcrumbStyles.separator,
        marginBottom: "8px", // Reduce from 16px to match production
      }}
    >
      <NavLink
        onClick={() => trackClick("/drugs")}
        style={({ isActive }) => ({
          ...breadcrumbStyles.breadcrumb,
          ...(isActive ? { fontWeight: "bold" } : {}),
        })}
        to={{
          pathname: `/drugs`,
          search: location.search,
        }}
      >
        <Typography component="h1" variant="body2" sx={breadcrumbStyles.typography}>
          Evidence Compendium
        </Typography>
      </NavLink>
      <NavLink
        onClick={() => trackClick(`/${activeTabKey}`)}
        style={({ isActive }) => ({
          ...breadcrumbStyles.breadcrumb,
          ...(isActive ? { fontWeight: "bold" } : {}),
        })}
        to={{
          pathname: `/${activeTabKey}`,
          search: location.search,
        }}
      >
        <Typography component="h2" variant="body2" sx={breadcrumbStyles.typography}>
          {tabConfig[activeTabKey]}
        </Typography>
      </NavLink>
    </Breadcrumbs>
  );
};

AppBreadcrumbs.propTypes = {
  location: shape({
    pathname: string.isRequired,
    search: string,
  }).isRequired,
  activeTabKey: string.isRequired,
};

export default AppBreadcrumbs;
